// LIFTED from ptc-tax-lifecycle web-app/src/components/listFilters/picklistSelection.ts @ 7af60ebb (C86, filter contract v3 §16.8, 2026-11-02),
// verbatim except ONE line: NO_VALUE_TOKEN is imported from core's '../columnFilterOps' (same value, '__TL_NO_VALUE__'). THE FLEET'S SHARED COPY: statetax and supervision copy FROM HERE (ptc-core), never a third copy.
/**
 * Pure translation between the lookup combobox's own UI model (a set of checked codes, an
 * "exclude" toggle, a "(has no value)" checkbox) and the `{ op, value }` shape the filter record
 * actually stores (fleet filter contract v3 §16.8 / C86, 2026-11-02). Kept separate from the
 * component so both directions are unit-testable without rendering anything.
 */
import { NO_VALUE_TOKEN } from '../columnFilterOps';

export interface LookupSelection {
  /** "Exclude these" toggle — true means the stored op is `notIn`. */
  excluding: boolean;
  /** Selected real option codes (never includes {@link NO_VALUE_TOKEN}). */
  codes: string[];
  /** The "(has no value)" checkbox. */
  includeNoValue: boolean;
}

export const EMPTY_SELECTION: LookupSelection = { excluding: false, codes: [], includeNoValue: false };

/**
 * Read a staged `{op, value}` pair into the combobox's UI model. Handles the legacy `containsData`/
 * `noData` operators too (an old saved view or hand-edited URL may still carry one) by translating
 * them into the equivalent selection under the new model, so re-opening a panel on old state never
 * shows an empty/broken control.
 */
export function readLookupSelection(op: string, value: string): LookupSelection {
  if (op === 'noData') return { excluding: false, codes: [], includeNoValue: true };
  if (op === 'containsData') return { excluding: true, codes: [], includeNoValue: true };
  const parts = value ? value.split(',').map((s) => s.trim()).filter((s) => s !== '') : [];
  const includeNoValue = parts.includes(NO_VALUE_TOKEN);
  const codes = parts.filter((p) => p !== NO_VALUE_TOKEN);
  return { excluding: op === 'notIn', codes, includeNoValue };
}

/** Write the combobox's UI model back to `{op, value}`. An empty selection writes an empty value
 * under the current op, which the caller treats the same as "no filter" (applyFilterValue already
 * drops an empty value). */
export function writeLookupSelection(sel: LookupSelection): { op: string; value: string } {
  const op = sel.excluding ? 'notIn' : 'in';
  const parts = [...sel.codes];
  if (sel.includeNoValue) parts.push(NO_VALUE_TOKEN);
  return { op, value: parts.join(',') };
}
